import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Immutable from 'immutable';
import { WysiwygField } from '../../../components';

import './style.scss';

const CartSummary = ({ showProducts }) => {
  const { t } = useTranslation();
  const commerce = useSelector((state) => state.get('commerce'));
  const totalNet = commerce.getIn(['cart', 'content', 'attributes', 'order_total', 'subtotal', 'formatted']);
  const totalWithTax = commerce.getIn(['cart', 'content', 'attributes', 'total_price', 'formatted']);

  return (
    <>
      {showProducts && commerce.getIn(['cart', 'products'], Immutable.List()).map((product) => {
        return (
          <div key={product.get('id')} className="CartPopup__product">
            <div className="CartPopup__product__titlerow">
              <div><strong>{parseInt(product.getIn(['attributes', 'quantity'], 1))}x {product.getIn(['relationships', 'purchased_entity', 'relationships', 'product_id', 'attributes', 'title'], product.getIn(['attributes', 'title'], ''))}</strong></div>
              <div>{product.getIn(['attributes', 'total_price', 'formatted'])}</div>
            </div>
            <WysiwygField
              property="schema:text"
              className="NodePracticalExample__intro subheading2"
              html={product.getIn(['relationships', 'purchased_entity', 'relationships', 'product_id', 'attributes', 'body', 'processed'])}
            />
          </div>
        );
      })}

      <div className="CartSummary__product__titlerow">
        <div>{t('cart.orderValue')}</div>
        <div>{totalNet}</div>
      </div>

      {commerce.getIn(['cart', 'content', 'attributes', 'order_total', 'adjustments'], Immutable.List()).map((adjustment) => {
        switch (adjustment.get('type')) {
          case 'shipping':
            return (
              <div key={adjustment.get('type')} className="CartSummary__product__titlerow"><div>{t('cart.shippingCost')}</div>
                <div>{adjustment.getIn(['total', 'formatted'])}</div>
              </div>
            );
          case 'tax':
            return (<div key={adjustment.get('type')} className="CartSummary__product__titlerow"><div>{t('cart.VAT')}</div><div>{adjustment.getIn(['total', 'formatted'])}</div></div>);
          default:
            break;
        }
      })}

      <hr />

      <div className="CartSummary__product__titlerow">
        <div><strong>{t('cart.totalWithVAT')}</strong></div>
        <div><strong>{totalWithTax}</strong></div>
      </div>
    </>

  );
};

export default CartSummary;
